<template>
<div id="editLevelModal" class="modal" @click="onCloseClicked()">
    <!-- Modal content -->
    <div class="modal-content" @click.stop="">
        <div class="my-modal-header">
            <p style="font-weight: bold;font-size: 22px;">{{isediting? 'Edit':'Add'}} Level</p>
            <span class="close" @click="onCloseClicked()"></span>
        </div>
        <div class="modal-body">
            <div class="row-item admin-row">
                <div class="left-side-key">Level Name</div>
                <input v-virtual-keyboard v-if="level" class=" right-side-value" v-model="level.name" />
            </div>
            <div class="row-item admin-row">
                <div class="left-side-key">Elevation (m)</div>
                <div class="left-title">Bottom</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" v-model="level.bottomElevation" />
                <div class="right-title">Top</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" style="margin-left: 5px;" v-model="level.topElevation" />
            </div>
            <div class="row-item admin-row">
                <div class="left-side-key">Northing (m)</div>
                <div class="left-title">South</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" v-model="level.south" />
                <div class="right-title">North</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" style="margin-left: 5px;" v-model="level.north" />
            </div>
            <div class="row-item admin-row">
                <div class="left-side-key">Easting (m)</div>
                <div class="left-title">West</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" v-model="level.west" />
                <div class="right-title">East</div>
                <input type="number" v-virtual-keyboard v-if="level" class="right-input" style="margin-left: 5px;" v-model="level.east" />
            </div>
        </div>
        <div class="modal-footer">
            <div class="admin-btn admin-btn-secondary" style="width:150px;" @click="onCloseClicked()">Close</div>
            <div class="admin-btn" style="width:200px;" @click="createOrEdit()">{{isediting?'Save':'Create'}} Level</div>
        </div>
    </div>

</div>
</template>

<script>
import { saveLevels, editType } from '@/utils/mongoUtils';
export default {
    name: 'EditLevel',
    data() {
        return {
            level: null,
            sourceLevel: null,
            isediting: false,
        };
    },
    methods: {
        createOrEdit() {
            this.level.name = this.level.name.trim();
            if (!this.level.name) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Please input a level name.'
                })
                return;
            }

            if (this.isediting) {
                if (this.$store.state.levels.some(o => o != this.sourceLevel && o.name == this.level.name)) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Level is already existing, please enter a unique name.'
                    })
                    return;
                }
                var index = this.$store.state.levels.findIndex(o => o.name == this.sourceLevel.name);
                this.$store.state.levels.splice(index, 1, this.level);
            } else {
                if (this.$store.state.levels.some(o => o.name == this.level.name)) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Level with same name is existing, please enter a unique name.'
                    })
                    return;
                }
                this.$store.state.levels.push(this.level);
            }
            this.$store.state.forgeService.fillLevelsDbids(this.$store.state.viewer)
            saveLevels(this.level, this.isediting ? editType.EDIT_LEVEL : editType.CREATE_LEVEL, () => {
                this.$store.state.levels = [...this.$store.state.levels];
            });
            this.$store.state.forgeService.getMappingExtension3D()?.updateShownLevels();

            this.onCloseClicked();
        },
        onCloseClicked() {
            this.level = null;
            document.getElementById("editLevelModal").style.display = "none";
        },

    },
}
</script>

<style>
.right-input {
    width: 30%;
    text-align: center;
}

.left-title {
    position: absolute;
    left: 41%;
    top: 0px;
    color: black;
    font-size: 10px;
}

.right-title {
    position: absolute;
    left: 72%;
    top: 0px;
    color: black;
    font-size: 10px;
}
.admin-row{
        margin-top: 10px;
}
</style>
